"use client";

import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { backgroundColorLevelCurrent, borderColorTertiary, boxShadowRaised, boxShadowDetached, boxShadowOverlaid, boxShadowPoppedOut, borderRadius, backgroundColorLevel2, backgroundColorLevel3, backgroundColorLevel4, backgroundColorLevel5 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const boxShadowsByDepth = {
  raised: boxShadowRaised,
  detached: boxShadowDetached,
  overlaid: boxShadowOverlaid,
  poppedOut: boxShadowPoppedOut
};
const depths = Object.keys(boxShadowsByDepth);
const ActualCard = styled.div.withConfig({
  componentId: "sc-14wiswp-0"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";box-shadow:", ";&{--background-color-level-current:", ";background:", ";}& &{--background-color-level-current:", ";}& & &{--background-color-level-current:", ";}& & & &{--background-color-level-current:", ";}"], backgroundColorLevelCurrent, borderColorTertiary, borderRadius, ({
  $depth
}) => boxShadowsByDepth[$depth], backgroundColorLevel2, backgroundColorLevelCurrent, backgroundColorLevel3, backgroundColorLevel4, backgroundColorLevel5);
const Card = /*#__PURE__*/forwardRef(({
  renderAs = "div",
  depth = "raised",
  ...props
}, ref) => /*#__PURE__*/_jsx(ActualCard, {
  $depth: depth,
  ...props,
  as: renderAs,
  ref: ref
}));
Card.displayName = "Card";
export default Card;
Card.propTypes = {
  /** Content to render inside the Card */
  children: PropTypes.node.isRequired,
  /** How the card should be rendered relative to surrounding layers */
  depth: PropTypes.oneOf(depths),
  /** The HTML tag string (e.g., `"div"`) or React component to render as. */
  renderAs: PropTypes.elementType
};